import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { Avatar, Box } from '@chakra-ui/react';
import theme from 'styles/themes/default';

import getUserDetail from 'api/users/getUserDetail';

import DrawerElement from 'components/atom/Drawer';
import Loader from 'components/atom/Loader';
import Text from 'components/atom/Text/styles';

import { BoxInfo, Container, Content } from './styles';

interface IProspection {
  isOpen: boolean;
  onclose: () => void;
  prospectionId: string | null;
}

const ProfileInfo: React.FC<IProspection> = ({ prospectionId, isOpen, onclose }) => {
  const { t } = useTranslation();

  const { data: prospectionData = null, isLoading: isProspectionLoading } = useQuery(
    ['getUserDetail', prospectionId],
    () => getUserDetail(prospectionId || ''),
    {
      enabled: !!prospectionId,
    },
  );

  return (
    <DrawerElement
      isOpen={isOpen}
      placement="right"
      onClose={onclose}
      size="sm"
      title={t('common:profile')}
    >
      <Container>
        {isProspectionLoading ? (
          <Loader />
        ) : prospectionData ? (
          <Content>
            <Box display="flex" alignItems="center" gap=".75rem">
              <Avatar
                size="lg"
                name={prospectionData.user.fullname}
                src={prospectionData.user.avatar}
              />

              <div>
                <Text weight="bold" size={22} lineHeight={25} color={theme.colors.darkBlue.color}>
                  {prospectionData.user.fullname}
                </Text>

                <Text size={15} lineHeight={22}>
                  {prospectionData.user.role}
                </Text>

                <Text size={14} lineHeight={18} weight="bold">
                  {prospectionData.user.companyFantasyName}
                </Text>
              </div>
            </Box>

            <Box marginTop="1.5rem">
              {prospectionData?.interests &&
                Object.keys(prospectionData.interests).length > 0 &&
                Object.keys(prospectionData.interests).map((key) => (
                  <BoxInfo key={key}>
                    <h6>{key}</h6>

                    <p>{prospectionData?.interests?.[key]}</p>
                  </BoxInfo>
                ))}

              {prospectionData.user.about && (
                <BoxInfo>
                  <h6>{t('meetings:prospection.presentation')}</h6>
                  <p> {prospectionData.user.about}</p>
                </BoxInfo>
              )}

              {/* prospectionData.user.language && (
                <BoxInfo>
                  <h6>{t('meetings:prospection.language')}</h6>
                  <p> {prospectionData.user.language}</p>
                </BoxInfo>
              ) */}
            </Box>
          </Content>
        ) : (
          <p>Não há informações para serem exibidas</p>
        )}
      </Container>
    </DrawerElement>
  );
};

export default ProfileInfo;
